export default __webpack_public_path__ + "static/media/news75.347b6e70.jpg";